import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@mui/styles'

import lang from '@/lang'
import getPhoneHref from '../_helpers/getPhoneHref'
import ThemeInterface from '@/theme-interface'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  // the header shows the contact from md up, below it moves to the end of the page
  root: {
    display: 'none',
    flexDirection: 'column',
    gap: 4,
    color: theme.palette.brand.text.primary,
    [theme.breakpoints.down('md')]: {
      display: 'flex',
    },
  },
  title: {
    fontWeight: theme.brandTypography.weights.semibold,
    color: theme.palette.brand.text.heading,
  },
  number: {
    color: theme.palette.brand.main,
    fontSize: theme.brandTypography.text.medium.fontSize,
  },
}))

interface CheckoutContactProps {
  className?: string
}

const CheckoutContact = ({ className }: CheckoutContactProps) => {
  const classes = useStyles()
  const { contactInfo } = lang.upgrade.wizard.footer

  return (
    <div className={clsx(classes.root, className)} data-qs-id='checkout-contact'>
      <span className={classes.title}>{contactInfo.title}</span>
      <a className={classes.number} href={getPhoneHref(contactInfo.number)} data-qs-id='checkout-contact-phone'>{contactInfo.number}</a>
      <span>{contactInfo.businessHours}</span>
    </div>
  )
}

export default CheckoutContact
